import { instance } from "libs/api";

import { ApiRoutesEarnings } from "../../constants";
import { CancelEarningsBody } from "./cancelEarnings.types";

export const requestCancelEarnings = async (
  body: CancelEarningsBody
): Promise<void> => {
  return await instance.patch(ApiRoutesEarnings.CancelEarnings, body);
};
